{
  "name": "neo-lms",
  "version": "1.0.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.4",
    "@angular/cdk": "^20.2.8",
    "@angular/common": "^20.3.4",
    "@angular/compiler": "^20.3.4",
    "@angular/core": "^20.3.4",
    "@angular/forms": "^20.3.4",
    "@angular/material": "^20.2.8",
    "@angular/platform-browser": "^20.3.4",
    "@angular/platform-browser-dynamic": "^20.3.4",
    "@angular/router": "^20.3.4",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^11.1.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.5",
    "@angular/cli": "^20.3.5",
    "@angular/compiler-cli": "^20.3.4",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.3"
  }
}
